import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter, Injectable, NgModule } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-confirma-limpar-campos',
  templateUrl: './modal-confirma-limpar-campos.component.html',
  styleUrls: ['./modal-confirma-limpar-campos.component.scss']
})
export class ModalConfirmaLimparCamposComponent implements OnInit {

  @Output() clear = new EventEmitter();

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private toastyService: ToastrService
  ) { }

  ngOnInit() {
  }

  confirmaLimpar() {
    this.toastyService.success('Os campos foram limpos!');
    this.activeModal.dismiss();
    this.clear.emit();
  }

}

